
// import React from "react";
export const colour = {
    Primary: "#4E4FA9",
    Secondary: "#E10098",
    Controls: "#4E4FA9",
    flow: "#E10098",
    texts: "#333333",
    text: "#777777 ",
    tablestrips: "#D9D9D929",
    control: "#DCDCD6;",
    graylight: "#F5F5F5",
    white: "#FFFFFF",
    grayDark: "#EFEFEF",
    lightPink: "#E100981A"
};

